import React from "react";
import { useCaptchaStore } from "@/common/store/captchaStore";
import Captcha from "@/components/UI/Captcha";
import { Popup } from "@/components/popups/Popup";
import "./CaptchaPopup.scss";

export const CaptchaPopup: React.FC = () => {
  const close = useCaptchaStore((state) => state.close);
  const resolve = useCaptchaStore((state) => state.resolve);

  const handleSuccess = (token: string) => {
    resolve?.(token);
    close();
  };

  const handleFailed = (err: string) => {
    console.error("Captcha failed:", err);
    close();
  };

  return (
    <Popup
      title="Too many requests"
      isOpen={true}
      popupClass="CaptchaPopup"
      onClose={close}
    >
      <p>
        Hey! We're thrilled you're enjoying the site so much.
        To ensure you're a real person, could you please complete the captcha below?
        Signing in will reduce these interruptions.
      </p>
      <Captcha
        id="global-captcha"
        onSuccess={handleSuccess}
        onFailed={handleFailed}
        onRendered={() => {}}
      />
    </Popup>
  );
};
